import styled from 'styled-components';

const StyledOfferStatusMessage = styled.p`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  margin: 0;
`;

export default StyledOfferStatusMessage;
